import classNames from "classnames";
import classes from "./button.module.css";

export type ButtonVariant = "primary" | "secondary";

export type ButtonSize = "normal" | "large";

export type ButtonProps = {
	label: string;
	url: string;
	variant: ButtonVariant;
	size?: ButtonSize;
};

export const Button = ({
	label,
	url,
	variant,
	size = "normal",
}: ButtonProps) => (
	<a
		href={url}
		className={classNames(classes.button, {
			[classes.primary]: variant === "primary",
			[classes.secondary]: variant === "secondary",
			[classes.large]: size === "large",
		})}
	>
		{label}
	</a>
);
